import { render, staticRenderFns } from "./question-subDetails.vue?vue&type=template&id=5d92f04f&scoped=true"
import script from "./question-subDetails.vue?vue&type=script&lang=js"
export * from "./question-subDetails.vue?vue&type=script&lang=js"
import style0 from "./question-subDetails.vue?vue&type=style&index=0&id=5d92f04f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d92f04f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d92f04f')) {
      api.createRecord('5d92f04f', component.options)
    } else {
      api.reload('5d92f04f', component.options)
    }
    module.hot.accept("./question-subDetails.vue?vue&type=template&id=5d92f04f&scoped=true", function () {
      api.rerender('5d92f04f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/question-subDetails.vue"
export default component.exports